"use strict"; // Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.

var _assertThisInitialized = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var vdom_1 = require("./vdom");

var algorithm_1 = require("@phosphor/algorithm");

var messaging_1 = require("@phosphor/messaging");

var properties_1 = require("@phosphor/properties");

var widgets_1 = require("@phosphor/widgets");

var React = __importStar(require("react"));
/**
 * The class name added to toolbars.
 */


var TOOLBAR_CLASS = 'jp-Toolbar';
/**
 * The class name added to toolbar items.
 */

var TOOLBAR_ITEM_CLASS = 'jp-Toolbar-item';
/**
 * The class name added to toolbar kernel name text.
 */

var TOOLBAR_KERNEL_NAME_CLASS = 'jp-Toolbar-kernelName';
/**
 * The class name added to toolbar spacer.
 */

var TOOLBAR_SPACER_CLASS = 'jp-Toolbar-spacer';
/**
 * The class name added to toolbar kernel status icon.
 */

var TOOLBAR_KERNEL_STATUS_CLASS = 'jp-Toolbar-kernelStatus';
/**
 * The class name added to a busy kernel indicator.
 */

var TOOLBAR_BUSY_CLASS = 'jp-FilledCircleIcon';
var TOOLBAR_IDLE_CLASS = 'jp-CircleIcon';
/**
 * A layout for toolbars.
 *
 * #### Notes
 * This layout automatically collapses its height if there are no visible
 * toolbar widgets, and expands to the standard toolbar height if there are
 * visible toolbar widgets.
 */

var ToolbarLayout = /*#__PURE__*/function (_widgets_1$PanelLayou) {
  _inherits(ToolbarLayout, _widgets_1$PanelLayou);

  var _super = _createSuper(ToolbarLayout);

  function ToolbarLayout() {
    var _this;

    _classCallCheck(this, ToolbarLayout);

    _this = _super.apply(this, arguments);
    _this._dirty = false;
    return _this;
  }
  /**
   * A message handler invoked on a `'fit-request'` message.
   *
   * If any child widget is visible, expand the toolbar height to the normal
   * toolbar height.
   */


  _createClass(ToolbarLayout, [{
    key: "onFitRequest",
    value: function onFitRequest(msg) {
      _get(_getPrototypeOf(ToolbarLayout.prototype), "onFitRequest", this).call(this, msg);

      if (this.parent.isAttached) {
        // If there are any widgets not explicitly hidden, expand the toolbar to
        // accommodate them.
        if (algorithm_1.some(this.widgets, function (w) {
          return !w.isHidden;
        })) {
          this.parent.node.style.minHeight = 'var(--jp-private-toolbar-height)';
        } else {
          this.parent.node.style.minHeight = '';
        }
      } // Set the dirty flag to ensure only a single update occurs.


      this._dirty = true; // Notify the ancestor that it should fit immediately. This may
      // cause a resize of the parent, fulfilling the required update.

      if (this.parent.parent) {
        messaging_1.MessageLoop.sendMessage(this.parent.parent, widgets_1.Widget.Msg.FitRequest);
      } // If the dirty flag is still set, the parent was not resized.
      // Trigger the required update on the parent widget immediately.


      if (this._dirty) {
        messaging_1.MessageLoop.sendMessage(this.parent, widgets_1.Widget.Msg.UpdateRequest);
      }
    }
    /**
     * A message handler invoked on an `'update-request'` message.
     */

  }, {
    key: "onUpdateRequest",
    value: function onUpdateRequest(msg) {
      _get(_getPrototypeOf(ToolbarLayout.prototype), "onUpdateRequest", this).call(this, msg);

      if (this.parent.isVisible) {
        this._dirty = false;
      }
    }
    /**
     * A message handler invoked on a `'child-shown'` message.
     */

  }, {
    key: "onChildShown",
    value: function onChildShown(msg) {
      _get(_getPrototypeOf(ToolbarLayout.prototype), "onChildShown", this).call(this, msg); // Post a fit request for the parent widget.


      this.parent.fit();
    }
    /**
     * A message handler invoked on a `'child-hidden'` message.
     */

  }, {
    key: "onChildHidden",
    value: function onChildHidden(msg) {
      _get(_getPrototypeOf(ToolbarLayout.prototype), "onChildHidden", this).call(this, msg); // Post a fit request for the parent widget.


      this.parent.fit();
    }
    /**
     * A message handler invoked on a `'before-attach'` message.
     */

  }, {
    key: "onBeforeAttach",
    value: function onBeforeAttach(msg) {
      _get(_getPrototypeOf(ToolbarLayout.prototype), "onBeforeAttach", this).call(this, msg); // Post a fit request for the parent widget.


      this.parent.fit();
    }
    /**
     * Attach a widget to the parent's DOM node.
     *
     * @param index - The current index of the widget in the layout.
     *
     * @param widget - The widget to attach to the parent.
     *
     * #### Notes
     * This is a reimplementation of the superclass method.
     */

  }, {
    key: "attachWidget",
    value: function attachWidget(index, widget) {
      _get(_getPrototypeOf(ToolbarLayout.prototype), "attachWidget", this).call(this, index, widget); // Post a fit request for the parent widget.


      this.parent.fit();
    }
    /**
     * Detach a widget from the parent's DOM node.
     *
     * @param index - The previous index of the widget in the layout.
     *
     * @param widget - The widget to detach from the parent.
     *
     * #### Notes
     * This is a reimplementation of the superclass method.
     */

  }, {
    key: "detachWidget",
    value: function detachWidget(index, widget) {
      _get(_getPrototypeOf(ToolbarLayout.prototype), "detachWidget", this).call(this, index, widget); // Post a fit request for the parent widget.


      this.parent.fit();
    }
  }]);

  return ToolbarLayout;
}(widgets_1.PanelLayout);
/**
 * A class which provides a toolbar widget.
 */


var Toolbar = /*#__PURE__*/function (_widgets_1$Widget) {
  _inherits(Toolbar, _widgets_1$Widget);

  var _super2 = _createSuper(Toolbar);

  /**
   * Construct a new toolbar widget.
   */
  function Toolbar() {
    var _this2;

    _classCallCheck(this, Toolbar);

    _this2 = _super2.call(this);

    _this2.addClass(TOOLBAR_CLASS);

    _this2.layout = new ToolbarLayout();
    return _this2;
  }
  /**
   * Get an iterator over the ordered toolbar item names.
   *
   * @returns An iterator over the toolbar item names.
   */


  _createClass(Toolbar, [{
    key: "names",
    value: function names() {
      var layout = this.layout;
      return algorithm_1.map(layout.widgets, function (widget) {
        return Private.nameProperty.get(widget);
      });
    }
    /**
     * Add an item to the end of the toolbar.
     *
     * @param name - The name of the widget to add to the toolbar.
     *
     * @param widget - The widget to add to the toolbar.
     *
     * @param index - The optional name of the item to insert after.
     *
     * @returns Whether the item was added to toolbar.  Returns false if
     *   an item of the same name is already in the toolbar.
     *
     * #### Notes
     * The item can be removed from the toolbar by setting its parent to `null`.
     */

  }, {
    key: "addItem",
    value: function addItem(name, widget) {
      var layout = this.layout;
      return this.insertItem(layout.widgets.length, name, widget);
    }
    /**
     * Insert an item into the toolbar at the specified index.
     *
     * @param index - The index at which to insert the item.
     *
     * @param name - The name of the item.
     *
     * @param widget - The widget to add.
     *
     * @returns Whether the item was added to the toolbar. Returns false if
     *   an item of the same name is already in the toolbar.
     *
     * #### Notes
     * The index will be clamped to the bounds of the items.
     * The item can be removed from the toolbar by setting its parent to `null`.
     */

  }, {
    key: "insertItem",
    value: function insertItem(index, name, widget) {
      var existing = algorithm_1.find(this.names(), function (value) {
        return value === name;
      });

      if (existing) {
        return false;
      }

      widget.addClass(TOOLBAR_ITEM_CLASS);
      var layout = this.layout;
      layout.insertWidget(index, widget);
      Private.nameProperty.set(widget, name);
      return true;
    }
    /**
     * Handle the DOM events for the widget.
     *
     * @param event - The DOM event sent to the widget.
     *
     * #### Notes
     * This method implements the DOM `EventListener` interface and is
     * called in response to events on the dock panel's node. It should
     * not be called directly by user code.
     */

  }, {
    key: "handleEvent",
    value: function handleEvent(event) {
      switch (event.type) {
        case 'click':
          if (!this.node.contains(document.activeElement) && this.parent) {
            this.parent.activate();
          }

          break;

        default:
          break;
      }
    }
    /**
     * Handle `after-attach` messages for the widget.
     */

  }, {
    key: "onAfterAttach",
    value: function onAfterAttach(msg) {
      this.node.addEventListener('click', this);
    }
    /**
     * Handle `before-detach` messages for the widget.
     */

  }, {
    key: "onBeforeDetach",
    value: function onBeforeDetach(msg) {
      this.node.removeEventListener('click', this);
    }
  }]);

  return Toolbar;
}(widgets_1.Widget);

exports.Toolbar = Toolbar;
/**
 * The namespace for Toolbar class statics.
 */

(function (Toolbar) {
  /**
   * Create an interrupt toolbar item.
   */
  function createInterruptButton(session) {
    return new ToolbarButton({
      iconClassName: 'jp-StopIcon jp-Icon jp-Icon-16',
      onClick: function onClick() {
        if (session.kernel) {
          session.kernel.interrupt();
        }
      },
      tooltip: 'Interrupt the kernel'
    });
  }

  Toolbar.createInterruptButton = createInterruptButton;
  /**
   * Create a restart toolbar item.
   */

  function createRestartButton(session) {
    return new ToolbarButton({
      iconClassName: 'jp-RefreshIcon jp-Icon jp-Icon-16',
      onClick: function onClick() {
        session.restart();
      },
      tooltip: 'Restart the kernel'
    });
  }

  Toolbar.createRestartButton = createRestartButton;
  /**
   * Create a toolbar spacer item.
   *
   * #### Notes
   * It is a flex spacer that separates the left toolbar items
   * from the right toolbar items.
   */

  function createSpacerItem() {
    return new Private.Spacer();
  }

  Toolbar.createSpacerItem = createSpacerItem;
  /**
   * Create a kernel name indicator item.
   *
   * #### Notes
   * It will display the `'display_name`' of the current kernel,
   * or `'No Kernel!'` if there is no kernel.
   * It can handle a change in context or kernel.
   */

  function createKernelNameItem(session) {
    return new Private.KernelName({
      session: session
    });
  }

  Toolbar.createKernelNameItem = createKernelNameItem;
  /**
   * Create a kernel status indicator item.
   *
   * #### Notes
   * It show display a busy status if the kernel status is
   * not idle.
   * It will show the current status in the node title.
   * It can handle a change to the context or the kernel.
   */

  function createKernelStatusItem(session) {
    return new Private.KernelStatus(session);
  }

  Toolbar.createKernelStatusItem = createKernelStatusItem;
})(Toolbar = exports.Toolbar || (exports.Toolbar = {}));
/**
 * React component for a toolbar button.
 *
 * @param props - The props for ToolbarButtonComponent.
 */


function ToolbarButtonComponent(props) {
  var handleMouseDown = function handleMouseDown(event) {
    event.preventDefault();
    props.onClick();
  };

  return React.createElement("button", {
    className: props.className ? props.className + ' jp-ToolbarButtonComponent' : 'jp-ToolbarButtonComponent',
    disabled: props.enabled === false,
    onMouseDown: handleMouseDown,
    title: props.tooltip || props.iconLabel
  }, props.iconClassName && React.createElement("span", {
    className: props.iconClassName + ' jp-ToolbarButtonComponent-icon'
  }), props.label && React.createElement("span", {
    className: "jp-ToolbarButtonComponent-label"
  }, props.label));
}

exports.ToolbarButtonComponent = ToolbarButtonComponent;
/**
 * Phosphor Widget version of ToolbarButtonComponent.
 */

var ToolbarButton = /*#__PURE__*/function (_vdom_1$ReactElementW) {
  _inherits(ToolbarButton, _vdom_1$ReactElementW);

  var _super3 = _createSuper(ToolbarButton);

  /**
   * Create a ToolbarButton.
   *
   * @param props - Props for ToolbarButtonComponent.
   */
  function ToolbarButton() {
    var _this3;

    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ToolbarButton);

    _this3 = _super3.call(this, React.createElement(ToolbarButtonComponent, Object.assign({}, props)));

    _this3.addClass('jp-ToolbarButton');

    return _this3;
  }

  return ToolbarButton;
}(vdom_1.ReactElementWidget);

exports.ToolbarButton = ToolbarButton;
/**
 * React component for a toolbar button that wraps a command.
 *
 * This wraps the ToolbarButtonComponent and watches the command registry
 * for changes to the command.
 */

var CommandToolbarButtonComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(CommandToolbarButtonComponent, _React$Component);

  var _super4 = _createSuper(CommandToolbarButtonComponent);

  function CommandToolbarButtonComponent(props) {
    var _this4;

    _classCallCheck(this, CommandToolbarButtonComponent);

    _this4 = _super4.call(this, props);
    props.commands.commandChanged.connect(_this4._onChange, _assertThisInitialized(_this4));
    _this4._childProps = Private.propsFromCommand(_this4.props);
    return _this4;
  }

  _createClass(CommandToolbarButtonComponent, [{
    key: "render",
    value: function render() {
      return React.createElement(ToolbarButtonComponent, Object.assign({}, this._childProps));
    }
  }, {
    key: "_onChange",
    value: function _onChange(sender, args) {
      if (args.id !== this.props.id) {
        return; // Not our command
      }

      if (args.type !== 'changed') {
        return; // Not a change
      }

      this._childProps = Private.propsFromCommand(this.props);
      this.forceUpdate();
    }
  }]);

  return CommandToolbarButtonComponent;
}(React.Component);

exports.CommandToolbarButtonComponent = CommandToolbarButtonComponent;
/**
 * Phosphor Widget version of ToolbarButtonComponent.
 */

var CommandToolbarButton = /*#__PURE__*/function (_vdom_1$ReactElementW2) {
  _inherits(CommandToolbarButton, _vdom_1$ReactElementW2);

  var _super5 = _createSuper(CommandToolbarButton);

  function CommandToolbarButton(props) {
    var _this5;

    _classCallCheck(this, CommandToolbarButton);

    _this5 = _super5.call(this, React.createElement(CommandToolbarButtonComponent, Object.assign({}, props)));

    _this5.addClass('jp-CommandToolbarButton');

    return _this5;
  }

  return CommandToolbarButton;
}(vdom_1.ReactElementWidget);

exports.CommandToolbarButton = CommandToolbarButton;
/**
 * A namespace for private data.
 */

var Private;

(function (Private) {
  function propsFromCommand(options) {
    var commands = options.commands,
        id = options.id;
    var iconClassName = commands.iconClass(id);
    var iconLabel = commands.iconLabel(id);
    var label = commands.label(id);
    var className = commands.className(id); // Add the boolean state classes.

    if (commands.isToggled(id)) {
      className += ' p-mod-toggled';
    }

    if (!commands.isVisible(id)) {
      className += ' p-mod-hidden';
    }

    var tooltip = commands.caption(id) || label || iconLabel;

    var onClick = function onClick() {
      commands.execute(id);
    };

    var enabled = commands.isEnabled(id);
    return {
      className: className,
      iconClassName: iconClassName,
      tooltip: tooltip,
      onClick: onClick,
      enabled: enabled
    };
  }

  Private.propsFromCommand = propsFromCommand;
  /**
   * An attached property for the name of a toolbar item.
   */

  Private.nameProperty = new properties_1.AttachedProperty({
    name: 'name',
    create: function create() {
      return '';
    }
  });
  /**
   * A no-op function.
   */

  function noOp() {
    /* no-op */
  }

  Private.noOp = noOp;
  /**
   * A spacer widget.
   */

  var Spacer = /*#__PURE__*/function (_widgets_1$Widget2) {
    _inherits(Spacer, _widgets_1$Widget2);

    var _super6 = _createSuper(Spacer);

    /**
     * Construct a new spacer widget.
     */
    function Spacer() {
      var _this6;

      _classCallCheck(this, Spacer);

      _this6 = _super6.call(this);

      _this6.addClass(TOOLBAR_SPACER_CLASS);

      return _this6;
    }

    return Spacer;
  }(widgets_1.Widget);

  Private.Spacer = Spacer;
  /**
   * React component for a kernel name button.
   *
   * This wraps the ToolbarButtonComponent and watches the kernel
   * session for changes.
   */

  var KernelNameComponent = /*#__PURE__*/function (_React$Component2) {
    _inherits(KernelNameComponent, _React$Component2);

    var _super7 = _createSuper(KernelNameComponent);

    function KernelNameComponent(props) {
      var _this7;

      _classCallCheck(this, KernelNameComponent);

      _this7 = _super7.call(this, props);
      props.session.kernelChanged.connect(_this7._onKernelChanged, _assertThisInitialized(_this7));
      _this7._childProps = {
        className: TOOLBAR_KERNEL_NAME_CLASS,
        onClick: function onClick() {
          _this7.props.session.selectKernel();
        },
        tooltip: 'Switch kernel',
        label: props.session.kernelDisplayName
      };
      return _this7;
    }

    _createClass(KernelNameComponent, [{
      key: "render",
      value: function render() {
        return React.createElement(ToolbarButtonComponent, Object.assign({}, this._childProps));
      }
      /**
       * Update the text of the kernel name item.
       */

    }, {
      key: "_onKernelChanged",
      value: function _onKernelChanged(session) {
        this._childProps.label = session.kernelDisplayName;
        this.forceUpdate();
      }
    }]);

    return KernelNameComponent;
  }(React.Component);

  Private.KernelNameComponent = KernelNameComponent;
  /**
   * Phosphor Widget version of ToolbarButtonComponent.
   */

  var KernelName = /*#__PURE__*/function (_vdom_1$ReactElementW3) {
    _inherits(KernelName, _vdom_1$ReactElementW3);

    var _super8 = _createSuper(KernelName);

    function KernelName(props) {
      var _this8;

      _classCallCheck(this, KernelName);

      _this8 = _super8.call(this, React.createElement(KernelNameComponent, Object.assign({}, props)));

      _this8.addClass('jp-KernelName');

      return _this8;
    }

    return KernelName;
  }(vdom_1.ReactElementWidget);

  Private.KernelName = KernelName;
  /**
   * A toolbar item that displays kernel status.
   */

  var KernelStatus = /*#__PURE__*/function (_widgets_1$Widget3) {
    _inherits(KernelStatus, _widgets_1$Widget3);

    var _super9 = _createSuper(KernelStatus);

    /**
     * Construct a new kernel status widget.
     */
    function KernelStatus(session) {
      var _this9;

      _classCallCheck(this, KernelStatus);

      _this9 = _super9.call(this);

      _this9.addClass(TOOLBAR_KERNEL_STATUS_CLASS);

      _this9._onStatusChanged(session);

      session.statusChanged.connect(_this9._onStatusChanged, _assertThisInitialized(_this9));
      return _this9;
    }
    /**
     * Handle a status on a kernel.
     */


    _createClass(KernelStatus, [{
      key: "_onStatusChanged",
      value: function _onStatusChanged(session) {
        if (this.isDisposed) {
          return;
        }

        var status = session.status;
        this.toggleClass(TOOLBAR_IDLE_CLASS, status === 'idle');
        this.toggleClass(TOOLBAR_BUSY_CLASS, status !== 'idle');
        var title = 'Kernel ' + status[0].toUpperCase() + status.slice(1);
        this.node.title = title;
      }
    }]);

    return KernelStatus;
  }(widgets_1.Widget);

  Private.KernelStatus = KernelStatus;
})(Private || (Private = {}));